import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch} from "react-redux";
import {RadioGroup} from "@mui/material";
import {ButtonMain, RadioMain, DateCalendarForm, CheckboxMain, CreateCancelButtons} from "components";
import {FindError, FindLoad, FindSuccess, newDateWithoutUtc, Notify, useModal, usePrimaryModal} from "utils";
import {Svg} from "assets";
import {httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, legsActions} from "store";

const ACTION_TYPE_DELETE = 'DELETE_TRIP'
const ACTION_TYPE_CANCEL = 'CANCEL_TRIP'
const ACTION_TYPE_UN_CANCEL = 'UN_CANCEL_TRIP'

export const DeleteCancelTrip = ({
                                     trip, cancel = false, unCancel = false, afterSuccess = () => {
    }, requestParams
                                 }) => {
    const ACTION_TYPE = cancel ? ACTION_TYPE_CANCEL : unCancel ? ACTION_TYPE_UN_CANCEL : ACTION_TYPE_DELETE
    const [isAccept, setIsAccept] = useState(false);
    const dispatch = useDispatch();
    const {closePrimary} = usePrimaryModal();
    const {close} = useModal();
    const success = FindSuccess(ACTION_TYPE);
    const beckError = FindError(ACTION_TYPE);
    const loading = FindLoad(ACTION_TYPE)

    const {
        control,
        watch,
        handleSubmit,
        setValue
    } = useForm({
        defaultValues: {
            isThisTrip: 'true'
        }
    })
    const isThisTrip = watch('isThisTrip') === 'true'

    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            Notify(`Trip(s) successfully ${cancel ? 'canceled' : unCancel ? 'un-canceled' : 'deleted'}.`, 'success');
            // afterSuccess();
            closePrimary();
            close()
        }
    }, [success]);

    useEffect(() => {
        if (beckError?.error) {
            Notify('Something went wrong.', 'error')
            // if (beckError?.error?.startsWith('To do this action, the Leg needs to be in')) {
            //     Notify(`Only legs in Open ${cancel ? '' : 'or Assigned'}  status will be ${cancel ? 'canceled' : unCancel ? 'un-canceled' : 'deleted'}.`, 'info')
            // } else {
            //     Notify('Something went wrong.', 'error')
            // }
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        }
    }, [beckError])

    useEffect(() => {
        if (isAccept) {
            setValue('startDate', '')
            setValue('endDate', '')
        }

    }, [isAccept]);


    const handleIsAccept = (e) => {
        setIsAccept(e.target.checked)
    }

    const onSubmit = (data) => {
        const params = {}
        if (!isThisTrip) {
            if (!isAccept) {
                if (params.template) {
                    delete params.template
                }
                params.startDate = newDateWithoutUtc(data.startDate)
                params.endDate = data.endDate ? newDateWithoutUtc(data.endDate) : delete data.endDate

            } else {
                if (params.startDate) {
                    delete params.startDate
                }

                if (params.endDate) {
                    delete params.endDate
                }

                params.template = trip?.template
            }
        }

        if (cancel) {
            dispatch(legsActions.cancelTrip(trip?.id, params, true, requestParams));
        } else if (unCancel) {
            dispatch(legsActions.unCancelTrip(trip?.id, params, true, requestParams));
        } else {
            dispatch(legsActions.deleteTrip(trip?.id, params, true, requestParams));
        }
    }

    return (
        <
            form className='delete-cancel-trip-wrapper'
                 onSubmit={handleSubmit(onSubmit)}
        >
            <div className="modal-header-main" style={{alignItems: 'start'}}>
                <div>
                    <h2 className="modal-header-title">{cancel ? 'Cancel' : unCancel ? 'Un-cancel' : 'Delete'} Trip</h2>
                    {(!cancel && !unCancel) &&
                        <p className='modal-header-description'>
                            This action is irreversible, and once deleted.
                        </p>
                    }
                </div>

                <button
                    className="modal-close-btn-main"
                    type="button"
                    onClick={closePrimary}
                >
                    <Svg.CloseSvg/>
                </button>
            </div>
            <div className="modal-body-main">
                <RadioGroup className='radio-group-delete-trip'>
                    <RadioMain
                        control={control}
                        name='isThisTrip'
                        label='This Trip'
                        value={'true'}
                        labelPlacement='right'
                    />

                    <RadioMain
                        control={control}
                        name='isThisTrip'
                        label='Many Trips'
                        value={'false'}
                        labelPlacement='right'
                    />
                </RadioGroup>

                {!isThisTrip &&
                    <div>
                        <div className='flex-gap-16'>
                            <DateCalendarForm
                                control={control}
                                name='startDate'
                                label='From'
                                max={watch("endDate")}
                                disabled={isAccept}
                                rules={{
                                    required: !isAccept && 'This Field is required'
                                }}
                            />

                            <DateCalendarForm
                                control={control}
                                name='endDate'
                                label='To'
                                min={watch("startDate")}
                                disabled={isAccept}
                            />
                        </div>

                        <div style={{margin: '10px 0 16px'}}>
                            <CheckboxMain
                                label={`${cancel ? 'Cancel' : unCancel ? 'un-cancel' : 'Delete'} all eligible trips.`}
                                onChange={handleIsAccept}
                                checked={isAccept}
                            />
                        </div>
                    </div>
                }

                {/*<div className='delete-cancel-trip-note-wrapper'>*/}
                {/*    <Svg.Note2Svg/>*/}
                {/*    <p className='delete-cancel-trip-note-text'>*/}
                {/*        <span style={{fontWeight: 600}}>Note:</span>*/}
                {/*        {cancel ? 'Only legs in Open status will be canceled.' : 'Only legs in Open or Assigned status will be deleted.'}*/}
                {/*    </p>*/}
                {/*</div>*/}
            </div>

            <CreateCancelButtons
                classNameWrapperCreate={!cancel ? 'modals-delete-btn' : ''}
                createText={cancel || unCancel ? 'Confirm' : 'Delete Trips'}
                loading={!!loading?.length}
                onCancel={closePrimary}
                createBtnStyles={{
                    width: cancel ? 110 : 140,
                }}
            />
        </form>
    );
};

